var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { prefixExReact } from '../../../helpers/components';
var StyledLogo = styled.div.attrs(function () { return ({
    className: prefixExReact('logo'),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: auto,\n  height: 20px,\n  display: flex;\n"], ["\n  width: auto,\n  height: 20px,\n  display: flex;\n"])));
var Image = styled.img.attrs(function () { return ({
    className: prefixExReact('logo-image'),
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: auto;\n"], ["\n  height: 100%;\n  width: auto;\n"])));
var Logo = function (props) {
    var imageUrl = props.imageUrl, restProps = __rest(props, ["imageUrl"]);
    return (React.createElement(StyledLogo, __assign({}, restProps),
        React.createElement(Image, { src: imageUrl })));
};
Logo.defaultProps = {
    height: 'auto',
    width: 'auto',
};
export default Logo;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map